
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'SocutnoLogo',
    props: {
        small: { type: Boolean, default: false },
    },
})
